<div class="z-40 shadow-sm" [ngClass]="{ 'dark text-white-dark': store.semidark && store.menu === 'horizontal'}">
  <div class="relative flex w-full items-center bg-white px-5 py-2.5 dark:bg-[#0e1726]">
    <div class="horizontal-logo flex items-center justify-between lg:hidden ltr:mr-2 rtl:ml-2">
      <a (click)="navigateToTenant()" class="main-logo flex shrink-0 items-center">
        <img class="inline w-8 ltr:-ml-1 rtl:-mr-1" src="/assets/favicon.png" alt />
        <span class="hidden align-middle text-2xl font-bold transition-all duration-300 dark:text-white-light lg:inline ltr:ml-1.5 rtl:mr-1.5"
          >Source<span class="text-[#068CFE]">by</span></span
        >
      </a>

      <a
        href="javascript:;"
        class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-primary lg:hidden ltr:ml-2 rtl:mr-2"
        (click)="storeData.dispatch({type: 'toggleSidebar'})"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 7L4 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
          <path opacity="0.5" d="M20 12L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
          <path d="M20 17L4 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
        </svg>
      </a>
    </div>

    <!-- Back Button and Page Title (shown for detail pages) -->
    @if ((headerConfig$ | async)?.showBackButton) {
    <div class="flex flex-1 items-center gap-2">
      <h2 class="text-lg font-semibold text-[#0E121B] dark:text-white">{{ (headerConfig$ | async)?.pageTitle }}</h2>
    </div>
    } @if ((headerConfig$ | async)?.showSearch) {
    <div class="flex items-center space-x-1.5 dark:text-[#d0d2d6] sm:flex-1 lg:space-x-2 ltr:ml-auto ltr:sm:ml-0 rtl:mr-auto rtl:space-x-reverse sm:rtl:mr-0">
      <div class="flex gap-2 sm:ltr:mr-auto sm:rtl:ml-auto">
        <form
          class="absolute inset-x-0 top-1/2 z-10 mx-4 hidden -translate-y-1/2 sm:relative sm:top-0 sm:mx-0 sm:block sm:translate-y-0"
          [ngClass]="{ '!block': search }"
          (submit.prevent)="search = false"
        >
          <div class="relative"></div>
        </form>
      </div>
    </div>
    }

    <!-- Right side elements (always visible) -->
    <div class="flex items-center gap-2 ltr:ml-auto rtl:mr-auto">
      <!-- theme selector -->
      <div>
        @if (store.theme === 'light') {
        <a
          href="javascript:;"
          class="flex items-center rounded-lg border border-gray-200 p-2 hover:text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60"
          (click)="storeData.dispatch({type: 'toggleTheme', payload:'dark'})"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="1.5"></circle>
            <path d="M12 2V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M12 20V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M4 12L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path d="M22 12L20 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path opacity="0.5" d="M19.7778 4.22266L17.5558 6.25424" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path opacity="0.5" d="M4.22217 4.22266L6.44418 6.25424" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path opacity="0.5" d="M6.44434 17.5557L4.22211 19.7779" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            <path opacity="0.5" d="M19.7778 19.7773L17.5558 17.5551" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
          </svg>
        </a>
        } @if (store.theme === 'dark') {
        <a
          href="javascript:;"
          class="flex items-center rounded-lg border border-gray-200 p-2 hover:bg-white-light/90 hover:text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60"
          (click)="storeData.dispatch({type: 'toggleTheme', payload:'light'})"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.0672 11.8568L20.4253 11.469L21.0672 11.8568ZM12.1432 2.93276L11.7553 2.29085V2.29085L12.1432 2.93276ZM21.25 12C21.25 17.1086 17.1086 21.25 12 21.25V22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25ZM12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25C1.25 17.9371 6.06294 22.75 12 22.75V21.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75V1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75ZM15.5 14.25C12.3244 14.25 9.75 11.6756 9.75 8.5H8.25C8.25 12.5041 11.4959 15.75 15.5 15.75V14.25ZM20.4253 11.469C19.4172 13.1373 17.5882 14.25 15.5 14.25V15.75C18.1349 15.75 20.4407 14.3439 21.7092 12.2447L20.4253 11.469ZM9.75 8.5C9.75 6.41182 10.8627 4.5828 12.531 3.57467L11.7553 2.29085C9.65609 3.5593 8.25 5.86509 8.25 8.5H9.75ZM12 2.75C11.9115 2.75 11.8077 2.71008 11.7324 2.63168C11.6686 2.56527 11.6538 2.50244 11.6503 2.47703C11.6461 2.44587 11.6482 2.35557 11.7553 2.29085L12.531 3.57467C13.0342 3.27065 13.196 2.71398 13.1368 2.27627C13.0754 1.82126 12.7166 1.25 12 1.25V2.75ZM21.7092 12.2447C21.6444 12.3518 21.5541 12.3539 21.523 12.3497C21.4976 12.3462 21.4347 12.3314 21.3683 12.2676C21.2899 12.1923 21.25 12.0885 21.25 12H22.75C22.75 11.2834 22.1787 10.9246 21.7237 10.8632C21.286 10.804 20.7293 10.9658 20.4253 11.469L21.7092 12.2447Z"
              fill="currentColor"
            ></path>
          </svg>
        </a>
        }
      </div>
      <!-- Profile dropdown (only show in horizontal mode) -->

      <!-- language dropdown -->

      <!-- chats -->
      <!-- notifications -->
      <div class="dropdown mr-2 shrink-0">
        <div hlMenu>
          <button
            (click)="fetchNotifications()"
            type="button"
            hlMenuButton
            class="relative block rounded-lg border border-gray-200 p-2 hover:bg-white-light/90 hover:text-primary dark:border-white/10 dark:bg-dark/40 dark:hover:bg-dark/60"
          >
            <icon-notification class="h-4 w-4"></icon-notification>
            @if (hasUnreadNotifications) {
            <span class="absolute top-0 flex h-3 w-3 ltr:right-0 rtl:left-0">
              <span
                class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 ltr:-left-[3px] rtl:-right-[3px]"
              ></span>
              <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"></span>
            </span>
            }
          </button>
          @if (showActivityMenu()) {
          <ul
            *hlMenuItems
            @toggleAnimation
            class="custom-shadow relative top-10 !z-50 w-[300px] divide-y rounded-lg !py-0 text-dark dark:divide-white/10 dark:text-white-dark sm:w-[350px] ltr:-right-2 rtl:-left-2"
          >
            <li>
              <div class="flex h-full w-full items-center justify-between px-4 py-2 font-semibold">
                <div class="flex items-center gap-2">
                  <icon-notification1 class="h-4 w-4"></icon-notification1>
                  <h4 class="text-[16px] font-semibold text-primary">Notifications</h4>
                </div>
                <div class="flex items-center gap-1">
                  <button
                    type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]"
                    [ngClass]="{ 'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white': selectedNotifTab()==='all' }"
                    (click)="notificationType('all')"
                  >
                    All
                  </button>
                  <button
                    type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]"
                    [ngClass]="{ 'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white': selectedNotifTab()==='read' }"
                    (click)="notificationType('read')"
                  >
                    Read
                  </button>
                  <button
                    type="button"
                    class="rounded bg-[#F5F7FA] px-2 py-1 text-xs hover:bg-[#c3d9fa] dark:bg-[#1E293B]"
                    [ngClass]="{ 'bg-[#c3d9fa] text-black dark:!bg-[#6ba5fc3a] dark:text-white': selectedNotifTab()==='unread' }"
                    (click)="notificationType('unread')"
                  >
                    Unread
                  </button>
                </div>
              </div>
            </li>
            <app-notification
              [notifications]="notifications"
              [filteredNotifications]="filteredNotifications"
              (fetchNotifications)="fetchNotifications()"
              (closeNotificationPopup)="closeNotificationPopup()"
            ></app-notification>
          </ul>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- horizontal menu -->
  @if (store.menu === 'horizontal') {
  <div
    class="horizontal-menu-bar relative z-10 hidden border-t border-[#ebedf2] bg-white py-1.5 font-semibold text-black shadow-md dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white-dark lg:flex lg:items-center"
  >
    <ul
      class="horizontal-menu flex min-w-0 flex-1 items-center space-x-1.5 overflow-x-auto px-4 xl:space-x-2 rtl:space-x-reverse [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-thumb]:bg-gray-600 [&::-webkit-scrollbar]:h-1"
    >
      <!-- Dashboard -->
      <li class="menu nav-item relative shrink-0">
        <a routerLink="/dashboard" class="nav-link no-bg-active">
          <div class="flex items-center">
            <icon-menu-dashboard class="shrink-0"></icon-menu-dashboard>
            <span class="px-2 text-xs">Dashboard</span>
          </div>
        </a>
      </li>
      <!-- Tenant -->
      <li class="menu nav-item relative shrink-0" *appHasPermission="'list_tenants'">
        <a routerLink="/tenant" (click)="navigateToTenant()" class="nav-link no-bg-active">
          <div class="flex items-center">
            <svg class="shrink-0" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 9C3 6.17157 3 4.75736 3.87868 3.87868C4.75736 3 6.17157 3 9 3H15C17.8284 3 19.2426 3 20.1213 3.87868C21 4.75736 21 6.17157 21 9V15C21 17.8284 21 19.2426 20.1213 20.1213C19.2426 21 17.8284 21 15 21H9C6.17157 21 4.75736 21 3.87868 20.1213C3 19.2426 3 17.8284 3 15V9Z"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <path d="M7 3V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              <path d="M3 12H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <span class="px-2 text-xs">Organizations</span>
          </div>
        </a>
      </li>
      <!-- Buyer Management -->
      <li class="menu nav-item relative shrink-0" *appHasPermission="'list_buyers'">
        <a routerLink="/buyer-master/buyer-list" (click)="navigateToBuyerManagement()" class="nav-link no-bg-active">
          <div class="flex items-center">
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path
                id="bm"
                d="M17.5,9.167H13.333a2.5,2.5,0,0,0-2.5,2.5V17.5a2.5,2.5,0,0,0,2.5,2.5H17.5A2.5,2.5,0,0,0,20,17.5V11.667A2.5,2.5,0,0,0,17.5,9.167Zm.833,8.333a.834.834,0,0,1-.833.833H13.333A.834.834,0,0,1,12.5,17.5V11.667a.834.834,0,0,1,.833-.833H17.5a.834.834,0,0,1,.833.833ZM17.5,13.331a.833.833,0,0,1-.833.833h-2.5a.833.833,0,0,1,0-1.667h2.5A.833.833,0,0,1,17.5,13.331Zm0,2.5a.833.833,0,0,1-.833.833h-2.5a.833.833,0,1,1,0-1.667h2.5A.833.833,0,0,1,17.5,15.833ZM7.5,10a5,5,0,1,0-5-5A5.005,5.005,0,0,0,7.5,10Zm0-8.333A3.333,3.333,0,1,1,4.167,5,3.337,3.337,0,0,1,7.5,1.667ZM9.167,12.5a.833.833,0,0,1-.833.833H7.5a5.84,5.84,0,0,0-5.833,5.833.833.833,0,1,1-1.667,0,7.509,7.509,0,0,1,7.5-7.5h.833A.833.833,0,0,1,9.167,12.5Z"
                fill="currentColor"
              />
            </svg>
            <span class="px-2 text-xs">Buyers</span>
          </div>
        </a>
      </li>
      <!-- Suppliers -->
      <li class="menu nav-item relative shrink-0" *appHasPermission="'vendor_list'">
        <a routerLink="/vendor-master/vendor-list" (click)="navigateToVendorManagement()" class="nav-link no-bg-active">
          <div class="flex items-center">
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path
                id="vm"
                d="M19.994,13.588A1.589,1.589,0,0,1,18.463,15h-.516A1.61,1.61,0,0,1,16.4,13.333,1.61,1.61,0,0,1,14.85,15h-.516a1.61,1.61,0,0,1-1.548-1.667A1.61,1.61,0,0,1,11.237,15h-.516A1.59,1.59,0,0,1,9.19,13.588a.951.951,0,0,1,.079-.491l.3-.717a2.5,2.5,0,0,1,2.312-1.547h5.428a2.5,2.5,0,0,1,2.312,1.547l.3.717a.943.943,0,0,1,.079.491Zm-1.649,2.245a.833.833,0,0,0-.834.833V17.5a.834.834,0,0,1-.834.833H12.508a.834.834,0,0,1-.834-.833v-.833a.834.834,0,0,0-1.668,0V17.5a2.5,2.5,0,0,0,2.5,2.5h4.169a2.5,2.5,0,0,0,2.5-2.5v-.833A.833.833,0,0,0,18.345,15.833ZM1.668,5a5,5,0,1,1,5,5A5.007,5.007,0,0,1,1.668,5ZM3.335,5A3.335,3.335,0,1,0,6.671,1.667,3.338,3.338,0,0,0,3.335,5Zm3.335,6.667A6.677,6.677,0,0,0,0,18.333v.833a.834.834,0,0,0,1.668,0v-.833a5.007,5.007,0,0,1,5-5,.833.833,0,1,0,0-1.667Z"
                fill="currentColor"
              />
            </svg>
            <span class="px-2 text-xs">Suppliers</span>
          </div>
        </a>
      </li>
      <!-- Supplier Verification -->
      <li
        class="menu nav-item relative shrink-0"
        *appHasPermission="['vendor_kyc_verification_list', 'review_vendor_kyc', 'view_only_vendor_kyc']; match: 'any'"
      >
        <a routerLink="/vendor-kyc-master/vendor-kyc-list" (click)="navigateToVendorKYCManagement()" class="nav-link no-bg-active">
          <div class="flex items-center">
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path
                id="kyc"
                d="M14.583,20A5.417,5.417,0,1,1,20,14.583,5.423,5.423,0,0,1,14.583,20Zm0-9.167a3.75,3.75,0,1,0,3.75,3.75A3.755,3.755,0,0,0,14.583,10.833Zm.833,5.295L16.987,14.6a.833.833,0,1,0-1.161-1.195L14.25,14.937a.213.213,0,0,1-.3,0l-.73-.715a.834.834,0,0,0-1.166,1.192l.73.715a1.889,1.889,0,0,0,2.634,0ZM7.5,10a5,5,0,1,1,5-5,5.005,5.005,0,0,1-5,5Zm0-8.333A3.333,3.333,0,1,0,10.833,5,3.337,3.337,0,0,0,7.5,1.667Zm-5.833,17.5a5.838,5.838,0,0,1,5.1-5.788.833.833,0,1,0-.206-1.653A7.506,7.506,0,0,0,0,19.167a.833.833,0,1,0,1.667,0Z"
                fill="currentColor"
              />
            </svg>
            <span class="px-2 text-xs">Supplier Verification</span>
          </div>
        </a>
      </li>
      <!-- Team Management -->
      <li class="menu nav-item relative shrink-0" *appHasPermission="'list_team_users'">
        <a routerLink="/team-master/user-list" (click)="navigateToTeamManagement()" class="nav-link no-bg-active">
          <div class="flex items-center">
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path
                id="team-man"
                d="M10,13.333A3.333,3.333,0,1,1,13.333,10,3.333,3.333,0,0,1,10,13.333Zm0-5A1.667,1.667,0,1,0,11.667,10,1.667,1.667,0,0,0,10,8.333Zm5,10.833a5,5,0,0,0-10,0,.833.833,0,1,0,1.667,0,3.333,3.333,0,0,1,6.667,0,.833.833,0,1,0,1.667,0Zm0-12.5a3.333,3.333,0,1,1,3.333-3.333A3.333,3.333,0,0,1,15,6.667Zm0-5a1.667,1.667,0,1,0,1.667,1.667A1.667,1.667,0,0,0,15,1.667ZM20,12.5a5.005,5.005,0,0,0-5-5,.833.833,0,1,0,0,1.667A3.333,3.333,0,0,1,18.333,12.5.833.833,0,0,0,20,12.5ZM5,6.667A3.333,3.333,0,1,1,8.333,3.333,3.333,3.333,0,0,1,5,6.667Zm0-5A1.667,1.667,0,1,0,6.667,3.333,1.667,1.667,0,0,0,5,1.667ZM1.667,12.5A3.333,3.333,0,0,1,5,9.167.833.833,0,0,0,5,7.5a5,5,0,0,0-5,5,.833.833,0,0,0,1.667,0Z"
                fill="currentColor"
              />
            </svg>
            <span class="px-2 text-xs">Users</span>
          </div>
        </a>
      </li>
      <!-- Support -->
      <li class="menu nav-item relative shrink-0">
        <a routerLink="/support-master/support-helpdesk-list" (click)="navigateToSupport()" class="nav-link no-bg-active">
          <div class="flex items-center">
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="17.294" height="22" viewBox="0 0 17.294 22">
              <path
                id="support"
                d="M8.011,8.708a3.187,3.187,0,0,0,.326,1.409,3.638,3.638,0,0,0-.766,2.068,5.043,5.043,0,1,1,8.573-4.573,5.173,5.173,0,0,1,.083,1.678.913.913,0,0,1-.914.794h-.041a.891.891,0,0,1-.864-1.022,3.288,3.288,0,0,0-.073-1.13,3.21,3.21,0,0,0-6.324.777ZM4.445,7.521a6.88,6.88,0,0,1,7.233-5.673,7.033,7.033,0,0,1,6.415,7.21,2.925,2.925,0,0,1-2.941,2.858H12.947a1.829,1.829,0,1,0-.482,1.833h2.688a4.753,4.753,0,0,0,4.774-4.641A8.869,8.869,0,0,0,11.8.019,8.625,8.625,0,0,0,5.265,2.355,8.745,8.745,0,0,0,2.648,7.182a.917.917,0,0,0,.907,1.069.9.9,0,0,0,.891-.729Zm6.774,8.062A7.539,7.539,0,0,0,3.927,20.81a.917.917,0,1,0,1.75.546,5.787,5.787,0,0,1,5.541-3.94,5.786,5.786,0,0,1,5.541,3.94.917.917,0,0,0,.875.644.945.945,0,0,0,.273-.041.918.918,0,0,0,.6-1.149,7.539,7.539,0,0,0-7.292-5.227Z"
                transform="translate(-2.634)"
                fill="currentColor"
              />
            </svg>
            <span class="px-2 text-xs">Support</span>
          </div>
        </a>
      </li>
      <!-- Department Management -->
      <li class="menu nav-item relative shrink-0" *appHasPermission="'list_departments'">
        <a routerLink="/department-master/department-list" (click)="navigateToDepartmentManagement()" class="nav-link no-bg-active">
          <div class="flex items-center">
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_2107_277)">
                <path
                  d="M24 18.5V20.5C24 22.43 22.43 24 20.5 24H3.5C1.57 24 0 22.43 0 20.5V18.5C0 16.57 1.57 15 3.5 15H5.5C6.053 15 6.5 15.447 6.5 16C6.5 16.553 6.053 17 5.5 17H3.5C2.673 17 2 17.673 2 18.5V20.5C2 21.327 2.673 22 3.5 22H20.5C21.327 22 22 21.327 22 20.5V18.5C22 17.673 21.327 17 20.5 17H18.5C17.947 17 17.5 16.553 17.5 16C17.5 15.447 17.947 15 18.5 15H20.5C22.43 15 24 16.57 24 18.5ZM24 3.5V4.5C24 6.43 22.43 8 20.5 8H20V9C20 10.654 18.654 12 17 12H13V15.395L14.295 14.101C14.686 13.71 15.318 13.71 15.709 14.101C16.1 14.492 16.1 15.124 15.709 15.515L13.234 17.991C12.554 18.67 11.45 18.671 10.77 17.991L8.294 15.515C7.903 15.124 7.903 14.492 8.294 14.101C8.685 13.71 9.317 13.71 9.708 14.101L11 15.393V11.999H7C5.346 11.999 4 10.653 4 8.999V7.999H3.5C1.57 7.999 0 6.429 0 4.499V3.499C0 1.57 1.57 0 3.5 0H6.5C8.43 0 10 1.57 10 3.5V4.5C10 6.43 8.43 8 6.5 8H6V9C6 9.551 6.448 10 7 10H17C17.552 10 18 9.551 18 9V8H17.5C15.57 8 14 6.43 14 4.5V3.5C14 1.57 15.57 0 17.5 0H20.5C22.43 0 24 1.57 24 3.5ZM6.5 6C7.327 6 8 5.327 8 4.5V3.5C8 2.673 7.327 2 6.5 2H3.5C2.673 2 2 2.673 2 3.5V4.5C2 5.327 2.673 6 3.5 6H6.5ZM22 3.5C22 2.673 21.327 2 20.5 2H17.5C16.673 2 16 2.673 16 3.5V4.5C16 5.327 16.673 6 17.5 6H20.5C21.327 6 22 5.327 22 4.5V3.5Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_2107_277">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span class="px-2 text-xs">Departments</span>
          </div>
        </a>
      </li>
      <!-- Category Management -->
      <li class="menu nav-item relative shrink-0" *appHasPermission="'list_categories'">
        <a routerLink="/category-master/category-list" (click)="navigateToCategoryManagement()" class="nav-link no-bg-active">
          <div class="flex items-center">
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M4 5C4 3.89543 4.89543 3 6 3H10C11.1046 3 12 3.89543 12 5V9C12 10.1046 11.1046 11 10 11H6C4.89543 11 4 10.1046 4 9V5Z"
                fill="currentColor"
              />
              <path
                d="M4 15C4 13.8954 4.89543 13 6 13H10C11.1046 13 12 13.8954 12 15V19C12 20.1046 11.1046 21 10 21H6C4.89543 21 4 20.1046 4 19V15Z"
                fill="currentColor"
              />
              <path
                d="M14 5C14 3.89543 14.8954 3 16 3H18C19.1046 3 20 3.89543 20 5V7C20 8.10457 19.1046 9 18 9H16C14.8954 9 14 8.10457 14 7V5Z"
                fill="currentColor"
              />
              <path
                d="M14 11C14 9.89543 14.8954 9 16 9H18C19.1046 9 20 9.89543 20 11V19C20 20.1046 19.1046 21 18 21H16C14.8954 21 14 20.1046 14 19V11Z"
                fill="currentColor"
              />
            </svg>
            <span class="px-2 text-xs">Categories</span>
          </div>
        </a>
      </li>
    </ul>

    <!-- profile -->
    <div class="dropdown menu nav-item relative shrink-0 px-4 ltr:ml-auto rtl:mr-auto">
      <div hlMenu class="!block">
        <button type="button" hlMenuButton class="group relative block">
          @if (userProfileImageUrl) {
          <img
            [src]="userProfileImageUrl"
            (error)="imageService.getInitials(vendorData?.full_name)"
            [fallbackSize]="36"
            fallbackBgColor="#E3EAFD"
            fallbackTextColor="#2B3674"
            alt="Profile"
            class="h-8 w-8 rounded-full object-cover"
          />
          } @else{
          <div
            class="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-200 bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300 dark:border-gray-600 sm:h-10 sm:w-10"
          >
            <span class="text-xs font-semibold text-white shadow-sm"> {{ imageService.getInitials(vendorData?.full_name) }} </span>
          </div>
          }
        </button>
        <ul
          *hlMenuItems
          @toggleAnimation
          class="absolute right-0 top-full z-50 mt-2 w-[230px] rounded-md border border-gray-200 bg-white !py-0 font-semibold text-primary shadow-lg dark:border-[#191e3a] dark:bg-[#0e1726]"
        >
          <div class="flex items-center px-1.5 py-4">
            <div class="flex-none">
              @if(userProfileImageUrl){
              <img
                [src]="userProfileImageUrl"
                (error)="imageService.getInitials(vendorData?.full_name)"
                [fallbackSize]="32"
                fallbackBgColor="#E3EAFD"
                fallbackTextColor="#2B3674"
                alt="Profile"
                class="h-8 w-8 rounded-full object-cover"
                (error)="authService.onImageError($event, vendorData?.full_name)"
              />
              }@else{
              <div
                class="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-200 bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg transition-transform duration-300 dark:border-gray-600 sm:h-10 sm:w-10"
              >
                <span class="text-xs font-semibold text-white shadow-sm"> {{ imageService.getInitials(vendorData?.full_name) }} </span>
              </div>
              }
            </div>
            <div class="flex flex-col">
              <div class="truncate ltr:pl-4 rtl:pr-4">
                <h4 class="text-base">{{ vendorData?.full_name }}</h4>
                <a class="text-black/60 hover:text-primary dark:text-dark-light/60 dark:hover:text-white" href="javascript:;">{{ vendorData?.email_id }}</a>
              </div>
            </div>
          </div>
          <li>
            <a routerLink="/admin/profile" class="cursor-pointer border-t border-gray-200 pt-2 text-primary dark:border-white/10">
              <svg class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="6" r="4" stroke="currentColor" stroke-width="1.5" />
                <path
                  opacity="0.5"
                  d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>
              View Profile
            </a>
          </li>
          <li class="border-t border-white-light dark:border-white-light/10">
            <a (click)="signOut()" class="cursor-pointer !py-3 text-primary">
              <svg
                class="h-4.5 w-4.5 shrink-0 rotate-90 ltr:mr-2 rtl:ml-2"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.5"
                  d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Sign Out
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  }
</div>
